"use strict";

/*
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the
 * License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageBackend = exports.StorageBackend = void 0;
/**
 * Asynchronous storage APIs. All methods return a `Promise`.
 * All methods take the `DOMString`
 * IDL type (as it is the lowest common denominator).
 */
var StorageBackend = /** @class */function () {
  function StorageBackend() {}
  return StorageBackend;
}();
exports.StorageBackend = StorageBackend;
/**
 * A `StorageBackend` backed by `localstorage`.
 */
var LocalStorageBackend = /** @class */function (_super) {
  __extends(LocalStorageBackend, _super);
  function LocalStorageBackend(storage) {
    var _this = _super.call(this) || this;
    _this.storage = storage || window.localStorage;
    return _this;
  }
  LocalStorageBackend.prototype.getItem = function (name) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      var value = _this.storage.getItem(name);
      if (value) {
        resolve(value);
      } else {
        resolve(null);
      }
    });
  };
  LocalStorageBackend.prototype.removeItem = function (name) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      _this.storage.removeItem(name);
      resolve();
    });
  };
  LocalStorageBackend.prototype.clear = function () {
    var _this = this;
    return new Promise(function (resolve, reject) {
      _this.storage.clear();
      resolve();
    });
  };
  LocalStorageBackend.prototype.setItem = function (name, value) {
    var _this = this;
    return new Promise(function (resolve, reject) {
      _this.storage.setItem(name, value);
      resolve();
    });
  };
  return LocalStorageBackend;
}(StorageBackend);
exports.LocalStorageBackend = LocalStorageBackend;
